// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__33Jr8","disabled":"FileBtn_disabled__3wU_T","warn":"FileBtn_warn__1F2rs","fade":"FileBtn_fade__lblVR"};